import L from 'leaflet';
import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {Marker} from 'react-leaflet';
import intl from 'react-intl-universal';

import {returnPendingLeafletIcon} from '../../../../../../utils/Utils';

import ConfirmationPopup from './../../../ConfirmationPopup';

import './IconDrop.css';

@inject("appStore")
@observer
class IconDrop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drawing: false,
            mouseAttached: false
        }
    };

    componentDidMount = () => {
        this.props.appStore.tracking.event('Started Placing Marker');
        if (!this.props.appStore.pendingState.editing) {
            if (this.props.appStore.isMobile) {
                this.props.appStore.setPendingElementPosition(null);
                this.props.appStore.setConfirmationPopup(true);
                this.props.appStore.mapState.element.on("click", (e) => {
                    this.props.appStore.setPendingElementPosition(e.latlng);
                    this.props.appStore.mapState.element.off("click");
                    if (!this.props.appStore.tryAutoSave()) {
                        this.props.appStore.setSavePopup(true);
                    }
                    this.setState({
                        drawing: true
                    });
                });
            } else {
                this.setState({
                    mouseAttached: true
                });
                this.props.appStore.mapState.element.on("mousemove", (e) => {
                    this.props.appStore.setPendingElementPosition(e.latlng);
                });
                this.props.appStore.mapState.element.on("click", (e) => {
                    this.props.appStore.setPendingElementPosition(e.latlng);
                    L.DomUtil.removeClass(this.props.appStore.mapState.element.getContainer(), 'crosshair-cursor-enabled');
                    this.props.appStore.mapState.element.off("click");
                    this.props.appStore.mapState.element.off("mousemove");
                    if (!this.props.appStore.tryAutoSave()) {
                        this.props.appStore.setSavePopup(true);
                    }
                    this.setState({
                        mouseAttached: false
                    });
                });
            }
        }

    };
    updateElementPosition = () => {
        const {lat, lng} = this.editableElement.leafletElement.getLatLng();
        this.props.appStore.setPendingElementPosition({
            lat: lat,
            lng: lng
        });
    };
    onEditElementMount = (element) => {
        this.editableElement = element;
    };
    componentWillUnmount = () => {
        this.setState({
            mouseAttached: false
        });
        this.props.appStore.mapState.element.off("click");
        this.props.appStore.mapState.element.off("mousemove");
        this.props.appStore.tracking.event('Stopped Placing Marker');
    };
    drawEnd = () => {
        this.props.appStore.setConfirmationPopup(false);
        if (!this.props.appStore.tryAutoSave()) {
            this.props.appStore.setSavePopup(true);
        }
        this.props.appStore.tracking.event('Saved Marker');
    };

    render() {
        let icon = returnPendingLeafletIcon(this.props.appStore.pendingState.element.icon, this.state.mouseAttached);
        return (
            <div className="IconDrop">
                {this.props.appStore.pendingState.element && this.props.appStore.pendingState.element.position &&
                <Marker
                    position={this.props.appStore.pendingState.element.position}
                    draggable={true}
                    onDragend={this.updateElementPosition}
                    ref={this.onEditElementMount}
                    icon={icon}
                >
                </Marker>
                }

                {this.props.appStore.pendingState.confirmationPopup &&
                <ConfirmationPopup
                    handleDone={this.drawEnd}
                    drawStarted={this.state.drawing}
                    defaultMessage={intl.get("IconDrop.default_message")}
                    alternativeMessage={intl.get("IconDrop.alternative_message")}
                />
                }

            </div>
        );
    }
}

export default IconDrop;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/components/IconDrop/index.js